import { Facebook, Instagram } from "lucide-react";
import { SOCIALS } from "@/lib/api";

export function TikTokIcon({ size = 17 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 1 1-2.31-2.83v-3.5a6.37 6.37 0 1 0 5.76 6.33V8.69a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.12z" />
    </svg>
  );
}

function EbayIcon({ size = 17 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <rect x="1" y="1" width="22" height="22" rx="6" fill="#ffffff" />
      <text x="12" y="16.6" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="800" fontSize="10">
        <tspan fill="#E53238">e</tspan><tspan fill="#0064D2">b</tspan><tspan fill="#F5AF02">a</tspan><tspan fill="#86B817">y</tspan>
      </text>
    </svg>
  );
}

function CardmarketIcon({ size = 17 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <rect x="1.5" y="1.5" width="21" height="21" rx="5" fill="#0063B4" />
      <text x="12" y="16.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="10" fill="#ffffff">CM</text>
    </svg>
  );
}

function CardtraderIcon({ size = 17 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <rect x="1.5" y="1.5" width="21" height="21" rx="5" fill="#F25C05" />
      <text x="12" y="16.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="10" fill="#ffffff">CT</text>
    </svg>
  );
}

const ICONS = { instagram: Instagram, facebook: Facebook, tiktok: TikTokIcon, ebay: EbayIcon, cardmarket: CardmarketIcon, cardtrader: CardtraderIcon };

export default function SocialsRow({ labeled = false }) {
  return (
    <div className="flex flex-wrap gap-3">
      {SOCIALS.map((s) => {
        const Icon = ICONS[s.id];
        return (
          <a
            key={s.id}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`social-${s.id}`}
            aria-label={s.label}
            title={s.label}
            className={`rounded-full border border-white/15 flex items-center justify-center gap-2 text-zinc-400 hover:text-white hover:border-red-600 hover:bg-red-600/10 transition-all ${labeled ? "px-5 h-11" : "w-10 h-10"}`}
          >
            <Icon size={16} />
            {labeled && <span className="text-xs font-mono uppercase tracking-wider">{s.label}</span>}
          </a>
        );
      })}
    </div>
  );
}
